import { TaxNameProps } from '@helpers/getTaxNames';
import { Order } from '@services/requests/orderService/interface';
import {
  ContainerParameters,
  CustomCargoParameters,
  RouteInGroup,
  RouteStep,
  TruckParameters,
} from '@services/requests/orderService/types';
import React from 'react';
import ShoulderItem from 'src/components/pages/Products/components/RouteProduct/components/ShoulderItem';

/**
 * Пропсы компонента
 */
type RouteProductDetailStepsProps = {
  steps: RouteStep[];
  taxNames: TaxNameProps[];
  order: Order;
  isUseActualCourses: boolean;
  routeIndex: number;
  cargoType: 'container' | 'custom' | 'truck';
  containerParameters: ContainerParameters[];
  customCargoParameters: CustomCargoParameters[];
  truckParameters: TruckParameters[];
  routes: RouteInGroup[];
};

/**
 * Компонент вывода шагов маршрута с описанием плечей и терминалов
 * @param props
 */
const RouteProductDetailSteps = (props: RouteProductDetailStepsProps) => {
  const {
    steps,
    taxNames,
    order,
    isUseActualCourses,
    routeIndex,
    cargoType,
    containerParameters,
    customCargoParameters,
    truckParameters,
	routes
  } = props;

  return (
    <>
      {steps.map((step) => (
        <ShoulderItem
          key={step.shoulder.id}
          step={step}
          taxNames={taxNames}
          order={order}
          isUseActualCourses={isUseActualCourses}
          routeIndex={routeIndex}
		  routes={routes}
          cargoType={cargoType}
          containerParameters={containerParameters}
          customCargoParameters={customCargoParameters}
          truckParameters={truckParameters}
        />
      ))}
    </>
  );
};

export default RouteProductDetailSteps;
